import { sendCategoryFilterEvent } from '../../utils/event-triggers';
import storeEvent from '../../utils/store-event';

export default {
    onCreate() {
        this.mainClass = 'str-categories';
        this.takeoverClass = `${this.mainClass}__takeover`;
        this.state = {
            open: false,
            focusDisabled: true
        };
    },
    onMount() {
        this.body = document.querySelector('body');
        storeEvent.openMobileCatLayer.listen(() => {
            this.openCategories();
        });
    },
    openCategories: function() {
        this.state.open = true;
        this.body.classList.add(this.takeoverClass);
    },
    closeCategories: function() {
        this.state.open = false;
        this.body.classList.remove(this.takeoverClass);
    },
    fetchCategoryListings: function(url, evt) {
        evt.originalEvent.preventDefault();
        storeEvent.changeToTab.dispatch({
            tabIndex: 0,
            skipFocus: true
        });
        setTimeout(() => {
            sendCategoryFilterEvent({
                url: url,
                clickEvent: evt
            });
            this.closeCategories();
        }, 0);
    }
};
